import { useCallback, useState } from "react"
import { CorePaymentMethod } from "@oysterhr/schema"
import { Text, Alert } from "@oysterhr/ui"

import { isSepaOrBacsAccount, showDirectDebitMandate } from "../utils"
import { useCompanyPaymentsSettingsContext } from "../contexts/CompanyPaymentsSettingsContext"

interface InfoShareMandateAlertProps {
  paymentMethod: CorePaymentMethod
}

export const InfoShareMandateAlert = ({ paymentMethod }: InfoShareMandateAlertProps) => {
  const { paymentsMandateSetup } = useCompanyPaymentsSettingsContext()
  const [showMandateBanner, setShowMandateBanner] = useState(() => {
    return window.localStorage.getItem("paymentFlow-showMandateBanner") === "false" ? false : true
  })
  const handleCloseBanner = useCallback(() => {
    window.localStorage.setItem("paymentFlow-showMandateBanner", "false")
    setShowMandateBanner(false)
  }, [])

  return showMandateBanner &&
    paymentMethod &&
    isSepaOrBacsAccount(paymentMethod) &&
    // Do not show this on the new flow
    !paymentsMandateSetup &&
    showDirectDebitMandate(paymentMethod) ? (
    <Alert onRequestClose={handleCloseBanner} variation="info" className="flex items-center">
      <Alert.Icon />
      <Alert.Content>
        <div className="flex">
          <Text>Please share the</Text>
          &nbsp;
          <a
            href={paymentMethod.mandateUrl as string}
            target="_blank"
            className="font-normal underline"
          >
            mandate reference
          </a>
          &nbsp;
          <Text>with your bank to avoid Direct Debit rejections.</Text>
        </div>
      </Alert.Content>
    </Alert>
  ) : null
}
